<template>
  <div class="col">
    <BaseIndex
      ref="baseIndex"
      :modelNameSingular="modelNameSingular"
      :modelNamePlural="modelNamePlural"
      :loading="loading"
      :pageLoading="pageLoading"
      :table-headers="tableHeaders"
      :table-items="indexItems"
      :maskFields="maskFields"
      :infoHeaders="infoHeaders"
      @options-change="optionsChange"
      :serverItemsLength="totalItems"
      :loadOptions="options"
      :typeOperators="typeOperators"
      :serverFields="serverFields"
      @filter-confirm-action="applyFilters"
    >
      <template slot="new" v-if="$can('create', $router.currentRoute.name)">
        <New
          @entry-created="entryCreated"
          :modelNameSingular="modelNameSingular"
        />
      </template>

      <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
        <Edit
          :entry="item"
          @entry-updated="entryUpdated"
          :readOnly="true"
          :modelNameSingular="modelNameSingular"
        />
      </template>

      <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
        <Edit
          :entry="item"
          @entry-updated="entryUpdated"
          :modelNameSingular="modelNameSingular"
          :isEdit="true"
        />
      </template>

      <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
        <Delete
          :entry="item"
          @entry-destroyed="entryDeleted"
          :modelNameSingular="modelNameSingular"
        />
      </template>

      <template slot="action1" slot-scope="{ item }">
        <v-btn
          text
          title="Regras do Grupo de Tributação"
          icon
          link
          :to= "'/app/nfe/outbound/taxation_rules/' + item.id"
        >
          <v-icon>mdi-cog-transfer-outline</v-icon>
        </v-btn>
      </template>
    </BaseIndex>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      indexItems: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        { text: "#", align: "left", sortable: true, value: "id" },
        { text: "Nome", align: "left", sortable: true, value: "name" },
        { text: "NCM", value: "ncm.code" },
        { text: "Cultura(s)/Insumos", align: "left", sortable: true, value: "culturesText" },
        { text: "Tipo", align: "left", sortable: true, value: "itemTypeText" },
        { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
        // { field: 'price', mask: 'currency'},
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["id"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Grupo de Tributação"
    },
    modelNamePlural: {
      type: String,
      default: "Grupos de Tributações"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  created() {
    // this.loadServerEntries(true);
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: ALL_OUTBOUND_NFE_TAXATION_GROUPS_QUERY,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log(response.data);
          this.indexItems = response.data.globalContext.taxationGroupsIndex.taxationGroups; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.globalContext.taxationGroupsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.globalContext.taxationGroupsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.globalContext.taxationGroupsIndex.serverFields; // seta os campos que podem ser filtrados
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
  }
};

const ALL_OUTBOUND_NFE_TAXATION_GROUPS_QUERY = gql `
  query($input: IndexInputObject!) {
    globalContext {
      taxationGroupsIndex(input: $input){
        count
        typeOperators
        serverFields 
        taxationGroups {
          id
          name
          itemType
          itemTypeText
          ncmId
          ncm {
            code
          }
          cultures {
            id
            name
          }
          culturesText
          canBeDeleted
          undeletabilityReasons
        }
      }
    }
  }
`
</script>

<style scoped></style>
